import { render } from "./UnNftRewardInfo.vue?vue&type=template&id=744f2dca"
import script from "./UnNftRewardInfo.vue?vue&type=script&lang=js"
export * from "./UnNftRewardInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__